import { CALENDAR } from "../../constants/action-types";

const initialState = {
  calendarEventQueries: [],
  calendarEvents: undefined,
  campaign: undefined,
  providerExportModel: undefined,
  pageRefreshCounter : 0,
  savedOutputFieldConfig: []
};

const Calendar = (state = initialState, action) => {
  switch (action.type) {
    case CALENDAR.EVENT_QUERIES: {
      var clientChanged =
        state.calendarEventQueries.filter(
          (i) => i.clientId !== action.payload.clientId
        ).length > 0;
      var queries = state.calendarEventQueries;
      var events = state.calendarEvents;
      if (clientChanged) {
        queries = [];
        events = [];
      }
      queries.push(action.payload);

      return Object.assign({}, state, {
        calendarEventQueries: queries,
        calendarEvents: events,
      });
    }
    case CALENDAR.EVENTS: {
      return Object.assign({}, state, {
        calendarEvents: action.payload,
      });
    }
    case CALENDAR.APPEND_EVENTS: {
      let allEvents = state.calendarEvents.concat(action.payload);
      return Object.assign({}, state, {
        calendarEvents: allEvents,
      });
    }
    case CALENDAR.CLEAR_EVENTS: {
      return Object.assign({}, state, {
        calendarEvents: undefined,
      });
    }
    case CALENDAR.CAMPAIGN: {
      return Object.assign({}, state, {
        campaign: action.payload,
      });
    }
    case CALENDAR.SAVED_OUTPUT_CONFIGS: {
      return Object.assign({}, state, {
        savedOutputFieldConfig: action.payload,
      });
    }
    case CALENDAR.CLEAR_CAMPAIGN: {
      return Object.assign({}, state, {
        campaign: undefined,
      });
    }
    case CALENDAR.PROVIDER_EXPORT: {
      return Object.assign({}, state, {
        providerExportModel: action.payload,
      });
    }
    case CALENDAR.CLEAR_PROVIDER_EXPORT: {
      return Object.assign({}, state, {
        providerExportModel: undefined,
      });
    }
    case CALENDAR.PAGEREFRESH: {
      console.log("PAGEREFRESH Reducer");
      return Object.assign({}, state, {
        pageRefreshCounter: state.pageRefreshCounter + 1,
      });
    }
    case CALENDAR.CLEAR_ALL: {
      return initialState;
    }
    default:
      return state;
  }
};
export default Calendar;
